module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-4-d80cd2acc26891b1e8ba24e3ab59b872.jpg";